import React from "react";
import error404Svg from "../../assets/pictures/error404.svg";
import { Navbar, Footer, Breadcrumbs } from "../../components/shared";
import "./Error404.css";
function Error404() {
  return (
    <>
      <Navbar />
      <Breadcrumbs /><br />
      <div className="button-wrapper home-btn">
        <button to="/">முகப்புக்குத் திரும்பு</button>
      </div>
      <img src={error404Svg} alt="error-404" className="error-img" />
      <Footer />
    </>
  );
}
export default Error404;
